export default "__VITE_ASSET__5eObObpJ__"